import { ProjectSettingPayload } from "types/project.types";
import { axiosInstance } from "./axios";
import axios from "axios";
import { LLM_BASE_URL } from "utils/constant";

export const fetchProjectList = async (
    page: number,
    limit: number,
    team_id: string,
    search: string
) => {
    try {
        // &team_id=${team_id}
        return await axiosInstance.get(
            `project/list?page=${page}&perPage=${limit}&team_id=${team_id}&search=${search}`
        );
    } catch (error) {
        throw error;
    }
};

export const addInviteCollaborator = async (id: string, data: any) => {
    try {
        return await axiosInstance.post(`/project/${id}/invite`, data);
    } catch (error) {
        throw error;
    }
};

export const addProject = async (data: any) => {
    try {
        return await axiosInstance.post(`/project/`, data);
    } catch (error) {
        throw error;
    }
};

export const createPatent = async (data: any) => {
    try {
        return await axiosInstance.post(`/patent/create`, data);
    } catch (error) {
        throw error;
    }
};

export const getPatentDetails = async (patentId: string) => {
    try {
        return await axiosInstance.get(`/patent/${patentId}`);
    } catch (error) {
        throw error;
    }
};

export const getPatentNameById = async (id: string) => {
    try {
        return await axiosInstance.get(`/patent/patentName/${id}`);
    } catch (error) {
        throw error;
    }
};
export const getPatentVijilizedDetails = async (compareId: string, forceRefresh?: boolean) => {
    try {
        const payload = {
            compare_id: compareId,
        };
        
        // Add cache-busting query parameter if forceRefresh is true
        let url = `/patent/vijilize-details`;
        if (forceRefresh) {
            url += `?_t=${Date.now()}`;
        }
        
        return await axiosInstance.post(url, payload);
    } catch (error) {
        throw error;
    }
};

// to get presign url to upload file
export const createPatentPresignedUrl = async (data: any) => {
    try {
        return await axiosInstance.post(
            `/patent/create-patent-presigned-url`,
            data
        );
    } catch (error) {
        throw error;
    }
};

export const uploadFileToS3 = async (imageData: any) => {
    try {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": imageData.type,
            },
            body: imageData.file,
        };

        const response = await fetch(imageData.url, requestOptions);

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        return response;
    } catch (error) {
        console.log("error while uploading to s3 =>", error);
        throw error;
    }
};

export const s3PutUrlWithProgress = async (
    imageData: any,
    onProgress?: (percentage: number) => void
) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        // Upload progress event
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && onProgress) {
                const percentage = Math.round(
                    (event.loaded / event.total) * 100
                );
                onProgress(percentage);
            }
        };

        // Load completion event
        xhr.onload = () => {
            // Create a response object similar to fetch Response
            const response = {
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                headers: xhr
                    .getAllResponseHeaders()
                    .split("\r\n")
                    .reduce((acc: any, current) => {
                        const [name, value] = current.split(": ");
                        if (name) acc[name.toLowerCase()] = value;
                        return acc;
                    }, {}),
                body: xhr.response,
                text: () => Promise.resolve(xhr.responseText),
                json: () => Promise.resolve(JSON.parse(xhr.responseText)),
                xhr: xhr, // Include original XHR object if needed
            };

            if (response.ok) {
                resolve(response);
            } else {
                reject(new Error(`Upload failed with status: ${xhr.status}`));
            }
        };

        // Error event
        xhr.onerror = () => {
            reject(new Error("Network error occurred during upload"));
        };

        try {
            // Open and send the request
            xhr.open("PUT", imageData.url);
            xhr.setRequestHeader("Content-Type", imageData.type);
            xhr.send(imageData.file);
        } catch (error) {
            console.log("error while uploading to s3 =>", error);
            reject(error);
        }
    });
};

export const patentUploadSuccess = async (data: any) => {
    try {
        return await axiosInstance.post(`/patent/patent-upload-success`, data);
    } catch (error) {
        throw error;
    }
};

// call after s3 upload url
export const patentUploadStatus = async (payload: any) => {
    try {
        return await axiosInstance.post(
            `/patent/patent-upload-status`,
            payload
        );
    } catch (error) {
        throw error;
    }
};

// get project details
export const getProjectDetails = async (projectId: string, search: string) => {
    try {
        return await axiosInstance.get(
            `/project/${projectId}?search=${search}`
        );
    } catch (error) {
        throw error;
    }
};

export const deleteProject = async (projectId: any, teamId?: string) => {
    try {
        return await axiosInstance.delete(
            `/project/${projectId}${teamId ? `?team_id=${teamId}` : ""}`
        );
    } catch (error) {
        throw error;
    }
};
export const editProject = async (projectId: string, payload: any) => {
    try {
        return await axiosInstance.put(`/project/${projectId}`, payload);
    } catch (error) {
        throw error;
    }
};
export const deletePatentById = async (patentId: string) => {
    try {
        return await axiosInstance.delete(`/patent/${patentId}`);
    } catch (error) {
        throw error;
    }
};

// vijilize patent
export const startVijilize = async (payload: any) => {
    try {
        return await axiosInstance.post(`/patent/vijilize`, payload);
    } catch (error) {
        throw error;
    }
};

export const estimateVijilization = async (payload: {
    source_patent_ids: string[];
    target_document_count: number;
    target_url_count: number;
}) => {
    try {
        return await axiosInstance.post(`/patent/estimate-vijilization`, payload);
    } catch (error) {
        throw error;
    }
};

export const getVijilization = async (projectId: string, search?: string) => {
    try {
        return await axiosInstance.get(
            `/project/vijilizations/${projectId}?search=${search}`
        );
    } catch (error) {
        throw error;
    }
};

export const updateVijilization = async (
    vijilizationId: string,
    name: string,
    description?: string
) => {
    try {
        const payload: any = { name: name };
        if (description !== undefined) {
            payload.description = description;
        }
        return await axiosInstance.put(
            `/project/vijilization/${vijilizationId}`,
            payload
        );
    } catch (error) {
        throw error;
    }
};

export const deleteVijilization = async (vijilizationId: string) => {
    try {
        return await axiosInstance.delete(
            `/project/vijilization/${vijilizationId}`
        );
    } catch (error) {
        throw error;
    }
};

export const cancelVijilization = async (vijilizationId: string) => {
    try {
        return await axiosInstance.post(
            `/project/vijilization/${vijilizationId}/cancel`
        );
    } catch (error) {
        throw error;
    }
};

export const restartVijilization = async (vijilizationId: string) => {
    try {
        return await axiosInstance.post(
            `/project/vijilization/${vijilizationId}/restart`
        );
    } catch (error) {
        throw error;
    }
};

export const replicateVijilization = async (
    sourceVijilizationId: string,
    targetVijilizationId: string
) => {
    try {
        return await axiosInstance.post(`/project/vijilization/replicate`, {
            sourceVijilizationId,
            targetVijilizationId,
        });
    } catch (error) {
        throw error;
    }
};

export const getClaimChartByProjectId = async (
    projectId: string,
    search?: string
) => {
    try {
        let url = `/project/claim-charts/${projectId}`;
        if (search) {
            url = `${url}?search=${search}`;
        }
        return await axiosInstance.get(url);
    } catch (error) {
        throw error;
    }
};

export const getClaimChartById = async (claimChartId: string) => {
    try {
        return await axiosInstance.get(`/project/claim-chart/${claimChartId}`);
    } catch (error) {
        throw error;
    }
};

export const createNewClaimChart = async (payload: any) => {
    try {
        return await axiosInstance.post(`/project/claim-chart`, payload);
    } catch (error) {
        throw error;
    }
};
export const createToExistingClaimChart = async (
    existingClaimChartId: string,
    payload: any
) => {
    try {
        return await axiosInstance.post(
            `/project/claim-chart/${existingClaimChartId}/add`,
            payload
        );
    } catch (error) {
        throw error;
    }
};

export const updateClaimChart = async (
    claimChartId: string,
    name: string
) => {
    try {
        return await axiosInstance.put(
            `/project/claim-chart/${claimChartId}`,
            { name }
        );
    } catch (error) {
        throw error;
    }
};

export const deleteClaimChart = async (claimChartId: string) => {
    try {
        return await axiosInstance.delete(
            `/project/claim-chart/${claimChartId}`
        );
    } catch (error) {
        throw error;
    }
};

export const updateHeatmap = async (
    claimChartId: string,
    heatmapFileName: string
) => {
    try {
        return await axiosInstance.put(
            `/project/claim-chart/${claimChartId}/heatmap`,
            { heatmap_file_name: heatmapFileName }
        );
    } catch (error) {
        throw error;
    }
};

export const deleteHeatmap = async (claimChartId: string) => {
    try {
        return await axiosInstance.delete(
            `/project/claim-chart/${claimChartId}/heatmap`
        );
    } catch (error) {
        throw error;
    }
};

export const getInviteTeamMemberList = async (
    projectId: string,
    teamId: string
) => {
    try {
        return await axiosInstance.get(
            `/project/${projectId}/frequent-team-members/${teamId}`
        );
    } catch (error) {
        throw error;
    }
};

export const getProjectInviteRoles = async () => {
    try {
        return await axiosInstance.get(`/project/roles`);
    } catch (error) {
        throw error;
    }
};

export const getCollaborators = async (id: any, searchTerm: string) => {
    try {
        return await axiosInstance.post(`/project/${id}/collaborators`, {
            search: searchTerm,
        });
    } catch (error) {
        throw error;
    }
};

export const updateProjectSettings = async (
    projectId: string,
    projectSettingPayload: ProjectSettingPayload
) => {
    try {
        return await axiosInstance.put(
            `/project/${projectId}/settings`,
            projectSettingPayload
        );
    } catch (error) {
        throw error;
    }
};

export const leaveUserService = async (
    id: string | undefined,
    payload: any
) => {
    try {
        return await axiosInstance.put(`project/${id}/leave`, payload);
    } catch (error) {
        throw error;
    }
};

export const removeUserService = async (
    id: string | undefined,
    payload: any
) => {
    try {
        return await axiosInstance.put(`project/${id}/remove-user`, payload);
    } catch (error) {
        throw error;
    }
};

export const transferUserService = async (
    id: string | undefined,
    payload: any
) => {
    try {
        return await axiosInstance.put(
            `project/${id}/transfer-ownership`,
            payload
        );
    } catch (error) {
        throw error;
    }
};

export const getUserProjects = async (teamId: string) => {
    try {
        return await axiosInstance.get(
            `/project/user-projects?team_id=${teamId}`
        );
    } catch (error) {
        throw error;
    }
};

export const createUrl = async (data: any) => {
    try {
        return await axiosInstance.post(`/project/url/`, data);
    } catch (error) {
        throw error;
    }
};

export const updatePatentStatus = async (patentId: string) => {
    try {
        return await axiosInstance.post(`/patent/update-status/${patentId}`);
    } catch (error) {
        throw error;
    }
};

export const deleteUrlById = async (urlId: any) => {
    try {
        return await axiosInstance.delete(`/project/url/${urlId}`);
    } catch (error) {
        throw error;
    }
};

export const getPatentsStatusByProjectId = async (projectId: any) => {
    try {
        return await axiosInstance.get(`/project/patents-status/${projectId}`);
    } catch (error) {
        throw error;
    }
};

export const verifyPatentNumbers = async (data: any) => {
    try {
        return await axiosInstance.post(`/patent/verify-patent-numbers`, data);
    } catch (error) {
        throw error;
    }
};

export const processVerifiedPatents = async (data: any) => {
    try {
        return await axiosInstance.post(
            `/patent/process-verified-patents`,
            data
        );
    } catch (error) {
        throw error;
    }
};

export const addExaminerCitationsToProject = async (data: any) => {
    try {
        return await axiosInstance.post(`/patent/add-examiner-citations`, data);
    } catch (error) {
        throw error;
    }
};

export const getExaminerCitationsDetails = async (
    patentNumber: string,
    filePath?: string,
    projectId?: string,
    teamId?: string
) => {
    try {
        return await axiosInstance.post(
            `/patent/examiner-citations/${patentNumber}`,
            {
                file_path: filePath,
                project_id: projectId,
                team_id: teamId,
            }
        );
    } catch (error) {
        throw error;
    }
};

export const getUrlDetailsById = async (id: string) => {
    try {
        return await axiosInstance.get(`/project/url/details/${id}`);
    } catch (error) {
        throw error;
    }
};

export const copyImageForAnnotation = async (
    s3FilePath: string,
    projectId?: string,
    teamId?: string
) => {
    try {
        return await axiosInstance.post(`/patent/copy-image-for-annotation`, {
            s3_file_path: s3FilePath,
            project_id: projectId,
            team_id: teamId,
        });
    } catch (error) {
        throw error;
    }
};

export const updateAnnotatedImage = async (
    vijilizeId: any,
    markdownS3Path: string,
    annotationS3Path: string,
    annotatedImageData: string,
    projectId?: string,
    teamId?: string,
    formattedAnnotations?: any,
    annotationData?: any
) => {
    try {
        return await axiosInstance.post(`/patent/update-annotated-image`, {
            vijilizeId,
            markdownS3Path,
            annotationS3Path,
            annotatedImageData,
            project_id: projectId,
            team_id: teamId,
            imageAnnotations: formattedAnnotations,
            annotationData,
        });
    } catch (error) {
        throw error;
    }
};

export const getMarkdownContent = async (
    comparisonId: string,
    patentId: string,
    claimKey: string,
    isMatchedItem: boolean,
    annotationId: string = "",
    projectId?: string,
    teamId?: string
) => {
    try {
        return await axiosInstance.post(
            `/patent/${annotationId}/markdown-content`,
            {
                comparisonId,
                patentId,
                claimKey,
                isMatchedItem,
                project_id: projectId,
                team_id: teamId,
            }
        );
    } catch (error) {
        throw error;
    }
};

export const generateSearchQueries = async (
    filePath: string,
    patentId: string,
    publishedDate?: string,
    instruction?: string,
    websites?: string[],
    claimElements?: string[]
) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/IpVijil/generate_search_queries`,
            {
                file_path: filePath,
                patent_id: patentId,
                ...(publishedDate && { published_date: publishedDate }),
                ...(instruction && { instruction }),
                ...(websites && { websites }),
                ...(claimElements && claimElements.length > 0 && { claim_elements: claimElements }),
            }
        );
    } catch (error) {
        console.log({ generateSearchQueriesError: error });
        throw error;
    }
};

export const getSimilarProducts = async (payload: {
    patent_id: string;
    cache_key: string;
    product_query?: string;
    patent_query?: string;
    prior_art_query?: string;
    num_results?: number;
}) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/IpVijil/find_similar_products`,
            payload
        );
    } catch (error) {
        console.log({ getSimilarProductsError: error });
        throw error;
    }
};

export const getSearchQueriesCache = async (patentId: string) => {
    try {
        return await axiosInstance.get(`/patent/${patentId}/search-queries-cache`);
    } catch (error) {
        throw error;
    }
};

export const saveSearchQueriesCache = async (
    patentId: string,
    payload: {
        product_query: string;
        patent_query: string;
        prior_art_query: string;
        elements_for_profiling?: string[];
    }
) => {
    try {
        return await axiosInstance.post(`/patent/${patentId}/search-queries-cache`, payload);
    } catch (error) {
        throw error;
    }
};

export const getLatestSimilarProducts = async (patentId: string) => {
    try {
        return await axiosInstance.get(`/patent/${patentId}/similar-products-latest`);
    } catch (error) {
        throw error;
    }
};

export const getCachedExaminerCitations = async (patentId: string) => {
    try {
        return await axiosInstance.get(`/patent/${patentId}/examiner-citations-cached`);
    } catch (error) {
        throw error;
    }
};

export const getSimilarProductsCache = async (patentId: string, queryKey?: string) => {
    try {
        const params: any = {};
        if (queryKey) params.query_key = queryKey;
        return await axiosInstance.get(
            `/patent/${patentId}/similar-products-cache`,
            { params }
        );
    } catch (error) {
        throw error;
    }
};

export const saveSimilarProductsCache = async (
    patentId: string,
    queryKey: string,
    results: object
) => {
    try {
        return await axiosInstance.post(`/patent/${patentId}/similar-products-cache`, {
            query_key: queryKey,
            results,
        });
    } catch (error) {
        throw error;
    }
};

export const checkProjectStatus = async (projectId: any) => {
    try {
        const teamInfo: any = JSON.parse(localStorage.getItem('selectedTeam') as string);
        const teamId = teamInfo?.currentTeamId || null;

        const payload = {
            projectId, teamId
        }

        return await axiosInstance.post(`/project/check-project-status`, payload);
    } catch (error) {
        throw error;
    }
};

export const getPatentFigureImages = async (
    originalImagePath?: string,
    patentId?: string,
    projectId?: string,
    targetPatentId?: string,
    folderType?: "original_images" | "figures"
) => {
    try {
        const payload: any = {};
        if (originalImagePath) payload.original_image_path = originalImagePath;
        if (patentId) payload.patent_id = patentId;
        if (targetPatentId) payload.target_patent_id = targetPatentId;
        if (projectId) payload.project_id = projectId;
        if (folderType) payload.folder_type = folderType;
        return await axiosInstance.post(`/patent/patent-figure-images`, payload);
    } catch (error) {
        throw error;
    }
};

export const changeVijilizeImage = async (payload: any) => {
    try {
        return await axiosInstance.post(`/patent/change-vijilize-image`, payload);
    } catch (error) {
        throw error;
    }
};

export const changePatentImage = async (payload: {
    comparison_id: string;
    patent_figure_s3_path: string;
    annotation_id?: string;
    patent_id?: string;
    claim_key?: string;
}) => {
    try {
        return await axiosInstance.post(`/patent/change-patent-image`, payload);
    } catch (error) {
        throw error;
    }
};

export const reanalyzeSingleClaimElement = async (payload: {
    sourcePatentId: string;
    targetPatentId: string;
    claimElement: string;
    sourcePatentFigureS3Path: string;
    targetPatentFigureS3Path: string;
    projectId: string;
    teamId: string;
    instruction?: string;
    claimPreamble?: string;
    claimFeature?: string;
}) => {
    try {
        // Use dynamic LLM base URL from environment configuration
        const endpoint = `${LLM_BASE_URL}/IpVijil/llm/agent/single_claim_element_infringement`;
        
        // Transform payload to match Python API expected format
        const apiPayload = {
            input_variables: {
                sourcePatentId: payload.sourcePatentId,
                targetPatentId: payload.targetPatentId,
                claimElement: payload.claimElement,
                sourcePatentFigure: payload.sourcePatentFigureS3Path,
                targetPatentFigure: payload.targetPatentFigureS3Path,
                projectId: payload.projectId,
                teamId: payload.teamId,
                claimPreamble: payload.claimPreamble || "",
                claimFeature: payload.claimFeature || "",
                instruction: payload.instruction || "",
            },
            session_id: "", // Required field, empty string for now
        };
        
        console.log('Calling reanalyze API:', {
            url: endpoint,
            originalPayload: payload,
            apiPayload
        });
        
        // Get auth token
        const user = JSON.parse(localStorage.getItem("userData") as string);
        const headers: any = {
            'Content-Type': 'application/json',
        };
        
        if (user?.accessToken) {
            headers['Authorization'] = `Bearer ${user.accessToken}`;
        }
        
        const response = await axios.post(
            endpoint,
            apiPayload,
            { headers }
        );
        
        console.log('Reanalyze API full response:', response);
        console.log('Reanalyze API response.data:', response.data);
        console.log('Reanalyze API response.data.result:', response.data?.result);
        console.log('Reanalyze API response.data.image_coordinates:', response.data?.image_coordinates);
        console.log('Reanalyze API response.data.result?.image_coordinates:', response.data?.result?.image_coordinates);
        console.log('Reanalyze API response.data keys:', Object.keys(response.data || {}));
        if (response.data?.result) {
            console.log('Reanalyze API response.data.result keys:', Object.keys(response.data.result));
        }
        
        return response.data;
    } catch (error: any) {
        console.error('Reanalyze API error:', error);
        console.error('Error response:', error.response);
        console.error('Error details:', {
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        });
        throw error;
    }
};

export const updateReanalysisResult = async (payload: {
    annotationId?: string;
    comparisonId: string;
    patentId: string;
    claimKey: string;
    isMatchedItem: boolean;
    markdownContent: string;
    analysis: string;
    originalImagePath: string;
    patentFigurePath: string;
    figureNumber: string;
    isMatch?: boolean;
    matchPercentage?: number;
    citations?: any[];
    features?: any[];
    figureLegend?: any[];
    hexCode?: string;
    isSystemGenerated?: boolean;
    totalCost?: number;
    imageCoordinates?: any[];
    projectId?: string;
    teamId?: string;
    clickedItemIndex?: number;
    targetDocumentId?: string;
}) => {
    try {
        return await axiosInstance.post(`/patent/update-reanalysis-result`, payload);
    } catch (error) {
        throw error;
    }
};

export const updateVijilizationStatus = async (vijilizationId: string, status: string) => {
    try {
        return await axiosInstance.put(`/project/vijilization/${vijilizationId}`, { status });
    } catch (error) {
        throw error;
    }
};

export const updateCitationsForSingleComparison = async (payload: {
    index_name: string;
    result: {
        analysis: string;
        is_match: boolean;
        match_percentage: number;
        markdown_content: string;
        markdown_image: string;
        original_image_path: string;
        image_coordinates: any[];
        annotation_id: string;
        is_system_generated: boolean;
        patent_figure_path: string;
        figure_legend: any[];
        figure_number: string;
        features: any[];
        citations: any[];
        total_cost: number;
        hex_code: string;
    };
    team_id: string;
    vijilize_id: string;
}) => {
    try {
        // Get auth token
        const user = JSON.parse(localStorage.getItem("userData") as string);
        const headers: any = {
            'Content-Type': 'application/json',
        };
        
        if (user?.accessToken) {
            headers['Authorization'] = `Bearer ${user.accessToken}`;
        }
        
        const response = await axios.post(
            `${LLM_BASE_URL}/IpVijil/update-citations-for-single-comparison`,
            payload,
            { headers }
        );
        
        return response.data;
    } catch (error) {
        console.error('Update citations API error:', error);
        throw error;
    }
};
